import { types } from 'mobx-state-tree';
import { FieldState, FormState } from 'formstate';
import { noDuplicateUserName } from './validators/NoDuplicateUserNameValidator';
import { required } from '../shared/validators/RequiredValidator';
import { matchesRegExp } from '../shared/validators/RegularExpressionValidator';
import { matchesField } from '../shared/validators/FieldMatchValidators';
import { validateIf } from '../shared/validators/ValidIf';

const passwordComplexityKey = 'validation_verifyPasswordPattern';
const passwordMask = '************';
export const AccountCredentialsStore = types
  .model({
    userName: types.optional(types.string, ''),
    reservedUserName: types.maybe(types.string),
    existingAccount: types.boolean,
    userNameRegularExpression: types.string,
    passwordRegularExpression: types.string,
    isUsernameRequired: types.boolean,
    validated: types.optional(types.boolean, false)
  })
  .actions(self => ({
    updateStoreFromForm(form: any) {
      self.userName = self.isUsernameRequired ? form.userName : "";
      self.existingAccount = true;
    }
  }))
  .views(self => ({
    get supportsDisplay(): boolean {
      return true;
    },
    isMaskedPass(value: string) {
      return self.existingAccount && passwordMask === value;
    },
    get reactForm() {
      const passwordField = new FieldState(self.existingAccount ? passwordMask : '').disableAutoValidation().validators(
        required(),
        validateIf(
          value => !this.isMaskedPass(value),
          matchesRegExp(self.passwordRegularExpression, passwordComplexityKey)
        )
      );
      return new FormState({
        userName: new FieldState(self.userName.trim()).validators(
          validateIf(value => self.isUsernameRequired, (required())),
          matchesRegExp(self.userNameRegularExpression, 'VerifyUserNamePattern'),
          validateIf(value => value.trim() !== self.userName.trim(), noDuplicateUserName)
        ),
        password: passwordField,
        confirmPassword: new FieldState(self.existingAccount ? '************' : '')
          .disableAutoValidation()
          .validators(required(), matchesField(passwordField, 'validation_verifyEquals_confirmPassword'))
      });
    },
    getDataToSubmit() {
      const form = this.reactForm;

      const formData = {
        userName: self.isUsernameRequired ? form.$.userName.value.trim() : null,
        password: this.isMaskedPass(form.$.password.value) ? undefined : form.$.password.value,
        isUsernameRequired: self.isUsernameRequired
      };
      self.updateStoreFromForm(formData);
      return formData;
    },
    canProceed() {
      return !this.reactForm.hasError;
    }
  }))
  .actions(self => ({
    validateForm() {
      self.validated = true;
      return self.reactForm.validate();
    }
  }));
